import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Product from './Product';
import { Event } from './Tracking';
import './App.css';

const Products = (props) => {
	const clickProductHandler = (product) => {
		Event("User", `User clicked on product name: ${product.title_preview}, brand: ${product.brand}, asin: ${product.asin}`, "Products Index");
	};

	const [products, setProducts] = useState(props.products);

	const getProducts = () => {
		axios
			.get('/api/products')
			.then( products => {
				setProducts(products.data);
			})
			.catch(err => {
				setProducts([]);
			});
	}

	return (
		<div className="products products-main">
			{ products && products.length ? products.map(
				product => {
					return (
						<Link
							key={product.id}
							to={'/products/' + product.id}
							onClick={() => clickProductHandler(product)}>
								<Product key={product.id} product={product}/>
						</Link>
					)
				}
			) : getProducts() }
		</div>
	)
}

export default Products;



// WEBPACK FOOTER //
// ./src/Products.jsx